import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "team-info-drawer__header" }
const _hoisted_2 = { class: "title mr-auto" }
const _hoisted_3 = {
  key: 0,
  class: "v-tab__counter"
}
const _hoisted_4 = { class: "px-5" }
const _hoisted_5 = { class: "team-info__info-item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Трекер", -1)
const _hoisted_7 = { class: "team-info__info-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Супервайзер", -1)
const _hoisted_9 = { class: "team-info__info-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Этап", -1)
const _hoisted_11 = { class: "team-info__info-item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Статус", -1)
const _hoisted_13 = { class: "team-info__info-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Ключевое ограничение", -1)
const _hoisted_15 = {
  class: "team-info__info-item",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Комментарий к ограничению", -1)
const _hoisted_17 = { class: "team-info__info-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Execution/дневники", -1)
const _hoisted_19 = { class: "team-info__info-item" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Запрос на ресурсы", -1)
const _hoisted_21 = { class: "team-info__info-item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Чек-лист", -1)
const _hoisted_23 = { class: "checkbox-group" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-group__label mt-2" }, "Количественные цели этапа", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-group__label mt-4" }, "Качественные цели этапа", -1)
const _hoisted_26 = { class: "participants__item" }
const _hoisted_27 = {
  key: 0,
  class: "ceo-label"
}
const _hoisted_28 = { class: "reports pb-4" }
const _hoisted_29 = {
  key: 0,
  class: "px-5 mt-2 d-flex"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "reports__item-header" }
const _hoisted_32 = { class: "reports__item-date" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "reports__item-counter-label" }, "Execution / Дневник", -1)
const _hoisted_34 = { class: "reports__item-counter" }
const _hoisted_35 = { class: "mt-3" }
const _hoisted_36 = {
  key: 1,
  class: "no-reports-label"
}
const _hoisted_37 = { class: "reports" }

import { useAccountStore } from '@/stores/account';
import { useDialogStore } from '@/stores/dialogs';
import { useProgramsStore } from '@/stores/programs';
import { useUiStore } from '@/stores/ui';
import dayjs from 'dayjs';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import AddTeamDialog from './dialogs/AddTeamDialog.vue';
import VUserInfo from './VUserInfo.vue';
import TeamStatus from './TeamStatus.vue';
import TeamReports from './TeamReports.vue';
import ReportInfo from './ReportInfo.vue';
import VStub from './VStub.vue';
import { replace } from '@/utils/vue';
import VLimitTag from './VLimitTag.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheProgramDrawer',
  setup(__props) {

const accountStore = useAccountStore()

const uiStore = useUiStore()
const programsStore = useProgramsStore()
const drawer = computed<boolean>({
  get() {
    return !!uiStore.team
  },
  set(value) {
    if (!value) uiStore.team = null
  }
})

watch(() => drawer.value, (val) => {
  if (val === false) {
    uiStore.teamReportsPage = null
    uiStore.selectedReport = null
  }
})

watch(() => uiStore.team, async (team) => {
  if (team === null) return
  if (team.TrackerReport?.length > 0) {
    tabs.value = "tracker-reports"
  }
  programsStore.requestReports(team)
  programsStore.requestLastReport(team)
  const currentProgram = programsStore.programs.find(item => item.id === router.currentRoute.value.params.programId)
  if (currentProgram && !currentProgram.students) {
    await programsStore.requestStudents(currentProgram.id)
  }
})

const students = computed(() => {
  const currentProgram = programsStore.programs.find(item => item.id === router.currentRoute.value.params.programId)
  if (!currentProgram || !uiStore.team) return []

  const arr = []
  for (let studentId of uiStore.team.students) {
    const student = currentProgram.students?.find(item => item.id === studentId)
    if (!student) continue
    arr.push(student)
  }
  return arr
})

const diaryScore = computed(() => {
  const reports = uiStore.team?.reports as any[]
  if (!reports || reports.length === 0) return "-"

  return reports[reports.length-1].diaryScore + "/" + reports[reports.length-1].executionScore

  // const diaryScore = reports.reduce((sum, val) => sum + val.diaryScore, 0) / reports.length
  // const executionScore = reports.reduce((sum, val) => sum + val.executionScore, 0) / reports.length

  // return diaryScore.toFixed(1) + "/" + executionScore.toFixed(1)
})

const tabs = ref("info")
const dialogStore = useDialogStore()

const editTeam = () => {
  dialogStore.open(AddTeamDialog, { team: uiStore.team })
}

const drawerWidth = computed(() => {
  if (!uiStore.teamReportsPage) return 560
  return document.body.clientWidth - 255
})

const router = useRouter()
watch(() => router.currentRoute.value.query.team, (teamId) => {
  if (!teamId) return

  const currentProgram = programsStore.programs.find(item => item.id === router.currentRoute.value.params.programId)
  if (!currentProgram) return
  uiStore.team = currentProgram.teams.find(item => item.id === teamId)
  uiStore.teamReportsPage = 'reports'
}, { immediate: true })


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: _unref(drawer),
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(drawer) ? (drawer).value = $event : null)),
    temporary: "",
    location: "right",
    class: "team-info-drawer",
    width: _unref(drawerWidth)
  }, {
    default: _withCtx(() => [
      (!_unref(uiStore).teamReportsPage && !_unref(uiStore).selectedReport)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(uiStore).team?.name), 1),
              (_unref(accountStore).isDirector)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    icon: "mdi-pencil",
                    flat: "",
                    style: {"opacity":"0.6"},
                    onClick: editTeam
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                flat: "",
                class: "mr-n4",
                style: {"opacity":"0.6"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = false))
              })
            ]),
            _createVNode(_component_v_tabs, {
              modelValue: tabs.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tabs).value = $event)),
              color: "primary",
              class: "mb-2 mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { value: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Общая информация")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "participants" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Участники "),
                    ((_unref(students).length > 0))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(students).length), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "tracker-reports" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Отчеты трекера")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "supervisor-reports" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Отчеты супервайзера")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_window, {
              modelValue: tabs.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tabs).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: "info" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createVNode(VUserInfo, {
                          "user-id": _unref(uiStore).team?.trackerId
                        }, null, 8, ["user-id"])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        (_unref(uiStore).team?.supervisorId)
                          ? (_openBlock(), _createBlock(VUserInfo, {
                              key: 0,
                              "user-id": _unref(uiStore).team?.supervisorId
                            }, null, 8, ["user-id"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("-")
                            ], 64))
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(" " + _toDisplayString(_unref(programsStore).stages.find(item => item.id === _unref(uiStore).team?.programStageId)?.name || "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(TeamStatus, {
                          "stage-id": _unref(uiStore).team?.programStageId,
                          date: new Date().toISOString()
                        }, null, 8, ["stage-id", "date"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        ((_unref(uiStore).team?.limits?.length > 0))
                          ? (_openBlock(), _createBlock(VLimitTag, {
                              key: 0,
                              report: _unref(uiStore).team.limits[_unref(uiStore).team.limits.length-1]
                            }, null, 8, ["report"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("-")
                            ], 64))
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        ((_unref(uiStore).team?.limits?.length > 0))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_unref(uiStore).team.limits[_unref(uiStore).team.limits.length-1]?.fields["Комментарий к ограничению"] || "-"), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("-")
                            ], 64))
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createTextVNode(" " + _toDisplayString(_unref(diaryScore)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createTextVNode(" " + _toDisplayString(_unref(uiStore).team?.lastReport?.resourceRequest || "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uiStore).team?.checklist?.quantity, (item) => {
                            return (_openBlock(), _createBlock(_component_v_checkbox, {
                              "model-value": item.checked,
                              label: item.title,
                              "hide-details": ""
                            }, null, 8, ["model-value", "label"]))
                          }), 256)),
                          _hoisted_25,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uiStore).team?.checklist?.quality, (item) => {
                            return (_openBlock(), _createBlock(_component_v_checkbox, {
                              "model-value": item.checked,
                              label: item.title,
                              "hide-details": ""
                            }, null, 8, ["model-value", "label"]))
                          }), 256))
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "participants" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(students), (student) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(_component_v_avatar, {
                          image: student.avatar,
                          size: 28
                        }, null, 8, ["image"]),
                        _createElementVNode("div", null, _toDisplayString(student.name) + " " + _toDisplayString(student.surname), 1),
                        (_unref(uiStore).team?.ceoId === student.id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, "CEO"))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "tracker-reports" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_28, [
                      (_unref(uiStore).team?.reports?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              class: "ml-auto",
                              "prepend-icon": "mdi-compare-horizontal",
                              height: "40",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(uiStore).teamReportsPage = 'reports'))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Сравнение отчетов ")
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uiStore).team?.reports?.slice().reverse(), (report) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "reports__item",
                          onClick: ($event: any) => (_unref(uiStore).selectedReport = report)
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(VUserInfo, {
                              "user-id": report.trackerId
                            }, null, 8, ["user-id"]),
                            _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(dayjs)(report.date ).format("D MMMM")), 1)
                          ]),
                          _createVNode(_component_v_divider, { class: "my-4" }),
                          _hoisted_33,
                          _createElementVNode("div", _hoisted_34, _toDisplayString(report.executionScore + "/" + report.diaryScore), 1),
                          (report.changeStageRequest)
                            ? (_openBlock(), _createBlock(_component_v_divider, {
                                key: 0,
                                class: "my-4"
                              }))
                            : _createCommentVNode("", true),
                          (_unref(accountStore).isDirector && report.changeStageRequest)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "tracker-reports__change-stage",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createVNode(VUserInfo, {
                                  "user-id": report.trackerId,
                                  "only-name": ""
                                }, null, 8, ["user-id"]),
                                _createTextVNode(" запрашивает подтверждение контрольной точки "),
                                _createElementVNode("b", null, _toDisplayString(_unref(programsStore).stages.find(item => item.id === report.newProgramStageId)?.name), 1),
                                _createElementVNode("div", _hoisted_35, [
                                  _createVNode(_component_v_btn, {
                                    class: "mr-2",
                                    color: "primary",
                                    elevation: "0",
                                    onClick: ($event: any) => (_unref(programsStore).completeReportRequest(report))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Подтвердить")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_v_btn, {
                                    elevation: "0",
                                    onClick: ($event: any) => (_unref(programsStore).cancelReportRequest(report))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Отклонить")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_30))
                      }), 256)),
                      (_unref(uiStore).team?.reports && _unref(uiStore).team?.reports.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, " У этой команды ещё не выставляли отчеты "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "supervisor-reports" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(VStub, null, {
                        default: _withCtx(() => [
                          _createTextVNode("У этой команды супервайзер ещё не выставлял отчетов ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true),
      (_unref(uiStore).teamReportsPage)
        ? (_openBlock(), _createBlock(TeamReports, {
            key: 1,
            onToback: _cache[5] || (_cache[5] = ($event: any) => (_unref(uiStore).teamReportsPage = null))
          }))
        : _createCommentVNode("", true),
      (_unref(uiStore).selectedReport)
        ? (_openBlock(), _createBlock(ReportInfo, {
            key: 2,
            report: _unref(uiStore).selectedReport,
            onToback: _cache[6] || (_cache[6] = ($event: any) => (_unref(uiStore).selectedReport = null))
          }, null, 8, ["report"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})